import React from "react";
import { VisitInstanceId } from "../../messages";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";
import AppModal from "../Generic/AppModal/AppModal";

export type CancelVisitModalProps = {
  type: "CancelVisit";
  requestedInstances: VisitInstanceId[];
  onClickCancelVisit: (visitInstances: VisitInstanceId[]) => Promise<void>;
  onClickClose: () => void;
};

interface Props {
  isOpen: boolean;
  modalProps: CancelVisitModalProps;
}

export default function CancelVisitModal(props: Props) {
  return (
    <AppModal
      type="info"
      isOpen={true}
      message={translate(STRINGS.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT)}
      title={translate(STRINGS.CANCEL_VISIT)}
      actions={[
        {
          key: "yes",
          variant: "soft",
          color: "black",
          children: translate(STRINGS.YES),
          onClick: () => props.modalProps.onClickCancelVisit(props.modalProps.requestedInstances),
        },
        {
          key: "no",
          variant: "link",
          color: "black",
          children: translate(STRINGS.I_HAVE_CHANGED_MY_MIND),
          onClick: () => props.modalProps.onClickClose(),
        },
      ]}
    />
  );
}
